module.exports = __webpack_public_path__ + "img/plan-m.6e92e5d4.png";